import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FolderSpecialIcon(props: IconProps) {
    return <Icon {...props} iconKey={"folder_special"}/>
}
